import Alert from "../Alert/Alert";
import Button from "../Button/Button";
import { ExpiredTokenAlertProps } from "./ExpiredTokenAlert.types";

const ExpiredTokenAlert = (props: ExpiredTokenAlertProps) => {

  const { show, onConfirm } = props

  return (
    <Alert showAlert={show} onClose={() => {}}>
      <div className="sign-out-alert">
        <h2>Login session expired</h2>
        <p>Your session has expired. Please re-sign in to continue.</p>
        <Button title="Okay" onClick={onConfirm} type="full" />
      </div>
    </Alert>
  )
}

export default ExpiredTokenAlert